import React, { createContext, useContext, useEffect, useState } from "react";
import { AssetCategory } from "./models/AssetCategory";
import { AtticusMySQL } from "./apis/AtticusMySQL";
import { estateApi } from "./apis";
import { useAuthContext } from "./AuthContextWrapper";
interface Props {
  children: JSX.Element;
}

export interface AssetContextInterface {
  categories?: AssetCategory[];
  assetsLoaded?: boolean;
  refreshAssets?: (excludeFI?: boolean) => Promise<void>;
}

export const AssetContext = createContext<AssetContextInterface>({
  categories: undefined,
  assetsLoaded: undefined,
  refreshAssets: undefined,
});

export const AssetContextWrapper = ({ children }: Props): JSX.Element => {
  const { activeEstate, setActiveEstate } = useAuthContext()
  const [categories, setCategories] = useState<AssetCategory[] | undefined>();
  const [assetsLoaded, setAssetsLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      if (!categories) {
        setCategories?.(await AtticusMySQL.getAssetCategories());
      }
      if (activeEstate) {
        if (!activeEstate?.assets) {
          // NOTE: once assets is fully integrated into this app excluding FI like this will not be acceptable.
          //  We likely want to build an FI specific api since it's very much slower than pulling other assets
          activeEstate.assets = await estateApi.getAssets(
            activeEstate?.id,
            true
          );
        }
        setActiveEstate?.(activeEstate);
        setAssetsLoaded(true);
      }
    })();
  }, []);

  const refreshAssets = async (excludeFI = false): Promise<void> => {
    if (activeEstate) {
      activeEstate.assets = await estateApi.getAssets(
        activeEstate?.id,
        excludeFI
      );
      setActiveEstate?.(activeEstate);
    }
  };

  return (
    <AssetContext.Provider
      value={{
        categories,
        assetsLoaded,
        refreshAssets,
      }}
    >
      {children}
    </AssetContext.Provider>
  );
};
